var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.0007 2.66663C8.63667 2.66663 2.66733 8.63596 2.66733 16C2.66733 18.1226 3.17667 20.1213 4.058 21.9026L2.718 27.2613C2.41267 28.4813 3.518 29.588 4.73933 29.2826L10.098 27.9426C11.8793 28.824 13.878 29.3333 16.0007 29.3333C23.3647 29.3333 29.334 23.364 29.334 16C29.334 8.63596 23.3647 2.66663 16.0007 2.66663Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 18C23.7712 18 24.6667 17.1046 24.6667 16C24.6667 14.8954 23.7712 14 22.6667 14C21.5621 14 20.6667 14.8954 20.6667 16C20.6667 17.1046 21.5621 18 22.6667 18Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 18C10.4379 18 11.3333 17.1046 11.3333 16C11.3333 14.8954 10.4379 14 9.33334 14C8.22877 14 7.33334 14.8954 7.33334 16C7.33334 17.1046 8.22877 18 9.33334 18Z",
    fill: "black",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.cdd9c07776dbda9f0f897d6eff616d6d.svg";
export { ForwardRef as ReactComponent };